import { render, staticRenderFns } from "./CostPivotBQ.vue?vue&type=template&id=0b0c33e4&scoped=true"
import script from "./CostPivotBQ.vue?vue&type=script&lang=js"
export * from "./CostPivotBQ.vue?vue&type=script&lang=js"
import style0 from "./CostPivotBQ.vue?vue&type=style&index=0&id=0b0c33e4&prod&lang=scss&scoped=true"
import style1 from "./CostPivotBQ.vue?vue&type=style&index=1&id=0b0c33e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0c33e4",
  null
  
)

export default component.exports